import { ProjectRoleId } from "@clovis/server/src/app/domain/project/role";
import { z } from "zod";

export const validationSchema = z.object({
  projectId: z.string().uuid(),
  role: z.nativeEnum(ProjectRoleId),
  userId: z.string().uuid(),
});
